<template>
  <div class="program-manager">
    <div class="page-header">
      <div>
        <h1>{{ $t('bo.programs.title') }}</h1>
        <p>{{ $t('bo.programs.subtitle') }}</p>
      </div>
      <button type="button" class="btn-primary" @click="goCreate">
        {{ $t('bo.programs.newProgram') }}
      </button>
    </div>

    <AdminProgramList
      ref="listRef"
      @edit="handleEdit"
      @archive="handleArchive"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import AdminProgramList from './AdminProgramList.vue'
import adminProgramService from '@/services/adminProgramService'

const { t } = useI18n()
const router = useRouter()

const listRef = ref(null)

const goCreate = () => {
  router.push({ name: 'admin.programs.create' })
}

const handleEdit = (program) => {
  router.push({ name: 'admin.programs.edit', params: { id: program.id } })
}

const handleArchive = async (id) => {
  if (!confirm(t('bo.programs.confirmArchive'))) return
  try {
    await adminProgramService.archive(id)
    listRef.value?.loadPrograms()
  } catch (e) {
    alert(e.response?.data?.message || t('bo.programs.failedArchive'))
  }
}
</script>

<style scoped>
.program-manager {
  padding: 2rem;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.page-header h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem;
}

.page-header p {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
}

.btn-primary {
  padding: 0.5rem 1.25rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  white-space: nowrap;
}

.btn-primary:hover {
  background: #2563eb;
}
</style>
